<template>
  <div class="register">
    <div class="register-content" v-if="showReg">
      <p class="register-content-title">欢迎注册</p>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item prop="userType">
          <el-select v-model="ruleForm.userType" placeholder="请选择注册类型">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <!-- <el-radio-group v-model="ruleForm.userType">
            <el-radio :label="1">个人</el-radio>
            <el-radio :label="2">公司</el-radio>
          </el-radio-group> -->
        </el-form-item>
        <el-form-item prop="companyName" v-if="ruleForm.userType == 2">
          <el-input v-model="ruleForm.companyName" placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <el-form-item prop="idCardName">
          <el-input v-model="ruleForm.idCardName" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item prop="idCardNo">
          <el-input v-model="ruleForm.idCardNo" placeholder="请输入身份证号码"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="userName">
          <el-input v-model="ruleForm.userName" placeholder="请输入昵称"></el-input>
        </el-form-item> -->
        <el-form-item prop="mobilePhone">
          <el-input v-model="ruleForm.mobilePhone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="ruleForm.password" placeholder="请输入密码" show-password></el-input>
        </el-form-item>
        <el-form-item  v-if="ruleForm.userType">
          <div class="imgs" :style="ruleForm.userType != 2?'justify-content:flex-start;gap:20px':''">
            <uploadImage v-model="ruleForm.idCardBack" tip="身份证人像面"></uploadImage>
            <uploadImage v-model="ruleForm.idCardFront" tip="身份证国徽面"></uploadImage>
            <uploadImage v-model="ruleForm.businessLicense" tip="营业执照" v-if="ruleForm.userType == 2"></uploadImage>
          </div>
        </el-form-item>
      </el-form>
      <div class="register-content-checked">
        <el-checkbox v-model="checked"></el-checkbox>
        我已阅读并同意网站的<span style="color: #0C3ABF;cursor:pointer;" @click="linkTo(1)">《用户注册协议》</span><span style="color: #0C3ABF;cursor:pointer;" @click="linkTo(2)">《隐私协议》</span>
      </div>
      <div class="register-button" @click="submitForm('ruleForm')">注册</div>
      <span class="register-login">已有账号 <span style="color: #0C3ABF;cursor:pointer;" @click="login">立即登录</span></span>
    </div>
    <div class="register-content" v-else>
      <p>该账号信息已提交审核，请耐心等候...</p>
    </div>
    <el-dialog
      title=""
      :visible.sync="previewDia"
      width="64%"
      custom-class="preview"
      append-to-body
    >
        <h1>{{title}}</h1>
        <div class="argeement-content" v-html="detail">
        </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { register } from "../utils/login"
import  uploadImage  from "../components/uploadImage.vue"
import detail from "./user";
import policy from "./private";
var validatePass = (rule, value, callback) => {
  // console.log(value)
  if (value === '') {
    callback(new Error('请输入手机号'));
  } else {
    const phoneReg = /^1[3456789]\d{9}$/;
    if(phoneReg.test(value)){
      callback();
      // // console.log("???????")
      //   checkPhone(value).then(res=>{
      //   // console.log("resss",res)
      //   if(res.data.code == 0 && res.data.data == true){
      //     callback();
      //   }else{
      //     callback(new Error('该手机号已被注册!'));
      //   }
      // })
    }else{
      // console.log("@@@@@@@@")
      callback(new Error('请输入正确的手机号格式!'));
    }
  }
};
export default {
  components:{
    uploadImage
  },
  data() {
    return {
      options: [
        {
          label:"个人",
          value:"1"
        },
        {
          label:"企业",
          value:"2"
        }
      ],
      vscode: "获取验证码",
      timer: null,
      value: '',
      input: '',
      showReg:true,
      checked: true,
      ruleForm: {
        userName: '',
        mobilePhone: '',
        password: '',
        userType:undefined,
        companyName:"",
        idCardName:"",
        idCardNo:undefined,
        idCardFront:undefined,
        idCardBack:undefined,
        businessLicense:undefined
      },
      title:"",
      previewDia:false,
      detail:"",
      policy:"",
      rules: {
        // userName: [
        //   { required: true, message: '请输入用户名', trigger: 'blur' },
        // ],
        userType: [
          { required: true, message: '请选择注册类型', trigger: 'change' },
        ],
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
        ],
        idCardName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        idCardNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
        ],
        // idCardBack: [
        //   { required: true, message: '请上传身份证人像面', trigger: 'blur' },
        // ],
        // idCardFront: [
        //   { required: true, message: '请上传身份证国徽面', trigger: 'blur' },
        // ],
        // businessLicense: [
        //   { required: true, message: '请上传营业执照', trigger: 'blur' },
        // ],
        mobilePhone: [
          {validator: validatePass , trigger: "blur" }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.objectOptions = []
    // this.showReg = true
    // getALlXhszTeachType().then(res => {
    //   this.options2 = res.data.data
    // })
  },
  methods: {
    login() {
      this.$router.push({ path: '/login' });
    },
    submitForm(formName) {
      // console.log('??',this.ruleForm);
      if(!this.checked){
        this.$message.warning("请勾选《用户注册协议》《隐私协议》")
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(!this.ruleForm.idCardBack){
            this.$message.warning("请上传身份证人像面")
            return
          }
          if(!this.ruleForm.idCardFront){
            this.$message.warning("请上传身份证国徽面")
            return
          }
          if(!this.ruleForm.businessLicense && this.ruleForm.userType == 2){
            this.$message.warning("请上传营业执照")
            return
          }
          this.ruleForm.userName = this.ruleForm.idCardName
          register(this.ruleForm).then(res =>{
            if(res.data.message == "成功"){
              // this.$message.success(res.data.data)
              this.showReg = false
              setTimeout(()=>{
                this.$router.push({ path: '/login' });
              },3000)
            }else{
              this.$message.error(res.data.data);
            }
          })
        } else {
          return false;
        }
      });
    },
    linkTo(index){
      index == 1?this.detail = detail:this.detail = policy
      index == 1?this.title = "杭州珍炫科技有限公司用户注册协议":this.title = "杭州珍炫科技有限公司隐私政策"
      this.previewDia = true
    },
  },
};
</script>
  
<style lang="less"  scoped>
  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #0c3abf;
      border-color: #0c3abf;
  }
  .argeement-content{
    height: calc(100% - 75px);
    overflow-y: auto;
    padding-right: 20px;
    /deep/ h2{
      text-align: center;
      margin: 50px auto 20px;
      font-size: 26px;
      font-weight: 600;
      color: #363636;
    }
    /deep/ p{
      font-size: 18px;
      font-family: Source Han Sans CN;
      // font-weight: 400;
      color: #383838;
      text-indent: 2em;
      line-height: 48px;
    }
    /deep/ .bold{
      font-weight: 600;
    }
    /deep/ .bold-underline{
      font-weight: 600;
      text-decoration: underline;
    }
    /deep/ span{
      color:#D70000
    }
  }
  h1{
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #363636;
    line-height: 31px;
    margin-bottom: 52px;
    text-align: center;
    margin-left: -30px;
  }
 
.code {
  position: relative;

  span {
    position: absolute;
    right: 92px;
    color: #0C3ABF;
    cursor: pointer;
    top: 0;
    bottom: 0;
  }
}
.el-select {
  width: 100%;
  height: 40px;
  border-radius: 6px;
  display: block;
}
.el-cascader{
  width: 100%;
  height: 40px;
  border-radius: 6px;
  display: block;
}

.el-input {
  width: 100%;
  height: 40px;
  border-radius: 6px;
  display: block;
}
/deep/ .el-form-item__content{
  margin-left: 0!important;
}
/deep/ .el-input__inner {
  font-size: 14px !important;
}

/deep/ .el-form-item.is-error .el-input__inner {
  border-color: #0C3ABF !important;
}

/deep/ .el-form-item__error {
  color: #0C3ABF;
}
/deep/ .el-dialog{
  height: 82%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0!important;
}
/deep/ .el-dialog__header{
  padding: 0;
}
/deep/ .el-dialog__body{
  height: 100%;
  padding:58px 50px 43px  70px;
  box-sizing: border-box;
}
.imgs{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.register {
  background-image: url("../assets/register.png");
  width: 100vw;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;

  &-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 38px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    margin: auto;
    padding-top: 50px;

    img {
      width: 35px;
      margin-right: 20px;
    }
  }

  &-content {
    background: #FFFFFF;
    border-radius: 12px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    padding: 20px 50px 20px 50px;
    box-sizing: border-box;
    width: 460px;

    &-title {
      text-align: center;
      font-size: 24px;
      font-family: SourceHanSansSC-Medium, SourceHanSansSC;
      font-weight: 500;
      color: #000000;
    }

    &-checked {
      font-size: 12px;
      margin: 30px auto 10px;
      text-align: center;
      display: block;
    }
  }

  &-button {
    width: 100%;
    height: 40px;
    background: #0C3ABF;
    border-radius: 6px;
    margin: auto;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
  }

  &-login {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #48484A;
    margin: 20px auto;
    text-align: center;
    display: block;
  }
}
</style>